import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type LanguageId = Brand<string, 'languageId'>;
export type LanguagePrefix = Brand<string, 'languagePrefix'>;

export const LANGUAGE_PREFIX_LENGTH = 2;

export const LANGUAGE_SCHEMA: z.ZodType<ILanguage> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as LanguageId)
    .optional(),
  name: z.string(),
  prefix: z
    .string()
    .transform((s: string) => s as LanguagePrefix)
    .default('DE' as LanguagePrefix),
  isActive: z.boolean(),
  isStandard: z.boolean(),
});
export const LANGUAGES_SCHEMA: z.ZodType<ILanguage[]> =
  z.array(LANGUAGE_SCHEMA);

export interface ILanguage {
  id?: LanguageId;
  name: string;
  prefix: LanguagePrefix;
  isActive: boolean;
  isStandard: boolean;
}

export const DEFAULT_LANGUAGE_GERMAN: ILanguage = {
  id: '5555dd5f-3edf-4833-8ca5-3e5c56f8ca43' as LanguageId,
  name: 'Deutsch',
  prefix: 'DE' as LanguagePrefix,
  isActive: true,
  isStandard: true,
};

export const DEFAULT_LANGUAGES: ILanguage[] = [DEFAULT_LANGUAGE_GERMAN];
